import Circle from "@client/controls/Circle/component";
import Icon from "@client/controls/Icon/component";
import { formatToHtml } from "@client/lib/format";
import { getUserDisplayName } from "@client/lib/misc";
import { type I18n, IconType } from "@client/types";
import { UserProfilePicture } from "@common/components/ProfilePicture/component";
import { useI18n } from "@common/hooks/i18n";
import { isNull } from "lodash";
import React from "react";
import { getHtmlId } from "./lib";
import { type Forums } from "./types";

const getStatusColor = (isApproved: boolean | null): string => {
  if (isNull(isApproved)) return "var(--orange)";
  return isApproved ? "var(--green)" : "var(--red)";
};

const getStatusIcon = (isApproved: boolean | null): string => {
  if (isNull(isApproved)) return IconType.Pause;
  return isApproved ? IconType.Tick : IconType.Cross;
};

const getStatusText = (i18n: I18n, isApproved: boolean | null): string => {
  if (isNull(isApproved)) return i18n.awaitingModeration;
  return isApproved ? i18n.approved : i18n.declined;
};

type ParentCommentProps = {
  comment: Forums.PostComment;
  isParent: boolean;
};
export const QuoteComment = (props: ParentCommentProps) => (
  <a
    className="text_color"
    href={`#${getHtmlId(props.isParent ? props.comment.parentTicketCommentId! : props.comment.ticketCommentId)}`}
  >
    <span className="parent_comment_container">
      <span className="title">
        {getUserDisplayName({
          firstName: props.isParent ? props.comment.parentCommentUserFirstName : props.comment.userFirstName,
          lastName: props.isParent ? props.comment.parentCommentUserLastName : props.comment.userLastName
        })}
      </span>
      <span
        className="parent_comment single-line-ellipsis"
        dangerouslySetInnerHTML={{
          __html: formatToHtml(props.isParent ? props.comment.parentTicketComment || "" : props.comment.comment)
        }}
      />
    </span>
  </a>
);

type StatusProps = {
  isApproved: boolean | null;
};
export const Approved = (props: StatusProps) => {
  const i18n = useI18n();

  return props.isApproved ? null : (
    <span className="post_status" style={{ color: getStatusColor(props.isApproved) }}>
      <Icon iconClassName={getStatusIcon(props.isApproved)} />
      {getStatusText(i18n, props.isApproved)}
    </span>
  );
};

export const Forum = (x: { color: string; name: string }) => (
  <div className="post_forum">
    <Circle color={x.color} size={8} />
    &nbsp; {x.name}
  </div>
);

type PostAvatarProps = {
  noName?: boolean;
  post: Forums.Post;
};
export const PostAvatar = (props: PostAvatarProps) => (
  <UserProfilePicture
    firstName={props.post.contactFirstName}
    lastName={props.post.contactLastName}
    email={null}
    profilePictureMediaSourceId={props.post.contactProfilePictureSourceId}
    profilePictureMediaSourceKey={props.post.contactProfilePictureSourceKey}
    size={36}
  />
);
